module.exports = __webpack_public_path__ + "static/img/2-5.1001a59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-2/2-5.jpg
// module id = 732
// module chunks = 1